import { Edit, Form, SaveButton, useFileUploadState, useForm } from "@pankod/refine-antd";
import { IResourceComponentsProps, useOne } from "@pankod/refine-core";
import { Divider } from "antd";
import {
  BackgroundScreeningFormFields,
  DocumentUploadSection,
  useCountryLocationData
} from "components/backgroundscreening/backgroundScreeningForm";
import { CancelButton } from "components/utils/cancelButton";
import { IBackgroundScreening, IScreeningMetadata } from "interfaces";
import { DATAPROVIDER_LOOKUP, DATAPROVIDER_UPDATE, RESOURCE_PATH, STALE_DURATION } from "scripts/site";

export const BackgroundScreeningEdit: React.FC<IResourceComponentsProps> = () => {
  const { formProps, saveButtonProps, queryResult, formLoading, form } = useForm<IBackgroundScreening>({
    dataProviderName: DATAPROVIDER_UPDATE,
    redirect: "show",
  });

  useOne<IScreeningMetadata>({
    dataProviderName: DATAPROVIDER_LOOKUP,
    resource: RESOURCE_PATH.METADATA,
    id: RESOURCE_PATH.BACKGROUND_SCREENING,
    queryOptions: {
      enabled: true,
      staleTime: STALE_DURATION,
    },
  });

  const record = queryResult?.data?.data;

  const { onChange: onUploadChange, isLoading: isUploading } = useFileUploadState();

  // Get country and location data using shared hook
  const { countryProps, locations } = useCountryLocationData();

  return (
    <Edit
      title="Edit Background Screening Request"
      isLoading={formLoading}
      saveButtonProps={saveButtonProps}
      headerButtons={() => (
        <>
        </>
      )}
      footerButtons={() => (
        <>
          <SaveButton {...saveButtonProps} loading={isUploading}>Update</SaveButton>
          <CancelButton />
        </>
      )}
    >
      <Form
        {...formProps}
        autoComplete="off"
        layout="vertical"
      >
        {/* Shared form fields component */}
        <BackgroundScreeningFormFields
          form={form}
          countryProps={countryProps}
          locations={locations || []}
          onUploadChange={onUploadChange}
        />

        <Divider orientation="left">Document Uploads</Divider>

        {/* Shared document upload section for edit, pass id for file uploads */}
        <DocumentUploadSection onUploadChange={onUploadChange} id={record?.id} />
      </Form>
    </Edit>
  );
};
